import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const internationalInventoryFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.INTERNATIONAL_INVENTORY.filters}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const internationalInventoryListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.INTERNATIONAL_INVENTORY.list}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { internationalInventoryFiltersGet, internationalInventoryListGet };
